// src/components/UKK/UKK.jsx
import Accordion from "../../components/Accordion/Accordion";
import Header from "../../components/Headers/UKKHeader";
import UKKHelmetComponent from "./UKKHelmetComponent";
import { Link } from "react-router-dom";

/* eslint-disable react-refresh/only-export-components */
const UKK = () => {
  const trackAccordion = (kysymys) => {
    if (window.gtag) {
      window.gtag("event", "ukk_accordion_avattu", {
        kysymys,
        sivu: "ukk",
      });
    }
  };

  const pageShellClass =
    "relative min-h-screen w-full overflow-hidden bg-gradient-to-br from-page via-surface2 to-[#E9FBF7] px-4 pb-20 pt-24 text-[#111827] dark:from-darkpage dark:via-darksurface dark:to-darksurface2 dark:text-white sm:px-6 lg:px-8";

  const contentCardClass =
    "relative z-10 mx-auto max-w-5xl rounded-[2rem] border border-[#DDE7E5] bg-white/90 p-6 shadow-xl backdrop-blur-xl dark:border-darkborder dark:bg-[#111114]/95 sm:p-8";

  const headingClass =
    "mb-6 font-customFont2 text-3xl font-bold uppercase leading-none !text-[#111827] dark:!text-white sm:text-4xl";

  const linkClass =
    "font-bold underline decoration-primary decoration-2 underline-offset-4 transition hover:text-primary dark:hover:text-primary";

  return (
    <>
      <section className={pageShellClass}>
        <UKKHelmetComponent />

        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute left-1/2 top-16 h-72 w-72
            -translate-x-1/2 rounded-full bg-primary/15 blur-3xl
            dark:bg-primary/10
          "
        />

        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute -right-24 top-96 h-96 w-96
            rounded-full bg-[#30f2cf]/10 blur-3xl
            dark:bg-primary/10
          "
        />

        <Header />

        <div className={contentCardClass}>
          {/* ===============================
              VUOKRAUS JA PALVELUT
          =============================== */}
          <h2 className={headingClass}>
            Vuokraus ja palvelut
          </h2>

          <Accordion
            title="Miten vuokraan laitteita?"
            onToggle={() => trackAccordion("Miten vuokraan laitteita?")}
            answer={
              <>
                Aloita valitsemalla haluamasi <strong>vuokrausajankohta</strong>{" "}
                <Link to="/vuokrattavat" className={linkClass}>
                  Vuokrattavat-sivun
                </Link>{" "}
                yläreunasta. Näet heti laitteiden saatavuuden – varatut tuotteet
                on merkitty punaisella <strong>VARATTU</strong>-merkinnällä.
                <br /><br />
                Lisää haluamasi laitteet <strong>vuokrauskoriin</strong> ja siirry{" "}
                <Link to="/tee-varaus" className={linkClass}>
                  Tee varaus
                </Link>{" "}
                -sivulle. Täytä lomake huolellisesti ja lähetä varaus.
                <br /><br />
                Alustava varaus on voimassa <strong>2 tuntia</strong>. Saat
                sähköpostiisi vahvistuksen, johon vastaamalla varaus muuttuu
                sitovaksi.
              </>
            }
            ariaLabel="Accordion kysymys: Miten vuokraan laitteita?"
          />

          <Accordion
            title="Mitä maksutapoja voin käyttää?"
            onToggle={() => trackAccordion("Mitä maksutapoja voin käyttää?")}
            answer={
              <>
                Tarjoamme useita maksutapoja tilanteen ja asiakkaan mukaan:
                <br /><br />
                💵 <strong>Käteinen</strong><br />
                Maksu voidaan suorittaa käteisellä erikseen sovittaessa.
                <br /><br />
                📱 <strong>MobilePay</strong><br />
                Nopea ja helppo maksutapa yksityisasiakkaille.
                <br /><br />
                🧾 <strong>Lasku</strong><br />
                Yrityksille, yhdistyksille ja sovituille asiakkaille. Maksuaika
                on yleensä <strong>14 päivää</strong>.
              </>
            }
            ariaLabel="Accordion kysymys: Mitä maksutapoja voin käyttää?"
          />

          <Accordion
            title="Miten kuljetuspalvelu toimii?"
            onToggle={() => trackAccordion("Miten kuljetuspalvelu toimii?")}
            answer={
              <>
                Voit noutaa laitteet itse tai käyttää kuljetuspalveluamme.
                <br /><br />
                🚗 Henkilöauto: <strong>kilometrikorvaus</strong><br />
                🚚 HIRVI 350 -kuomukärry: <strong>kilometrikorvaus + 20 € / suunta</strong>,
                jos kuljetettavia laitteita on yli 5 kpl.
                <br /><br />
                Kuljetustarve ilmoitetaan{" "}
                <Link to="/tee-varaus" className={linkClass}>
                  varauslomakkeella
                </Link>.
              </>
            }
            ariaLabel="Accordion kysymys: Miten kuljetuspalvelu toimii?"
          />

          <Accordion
            title="Voitteko asentaa ja testata laitteet paikan päällä?"
            onToggle={() =>
              trackAccordion("Voitteko asentaa ja testata laitteet paikan päällä?")
            }
            answer={
              <>
                Kyllä. Tarjoamme <strong>asennus- ja opastuspalvelun</strong>{" "}
                kuljetuksen yhteydessä. Kytkemme, testaamme ja opastamme
                laitteiden käytössä paikan päällä.
              </>
            }
            ariaLabel="Accordion kysymys: Voitteko asentaa ja testata laitteet paikan päällä?"
          />

          <Accordion
            title="Voinko vuokrata mikrofonit ja telineet erikseen?"
            onToggle={() =>
              trackAccordion("Voinko vuokrata mikrofonit ja telineet erikseen?")
            }
            answer={
              <>
                Kyllä. Mikrofonit, telineet ja muut lisävarusteet löytyvät{" "}
                <Link to="/vuokrattavat#otherrentals" className={linkClass}>
                  Muut vuokrattavat
                </Link>{" "}
                -osiosta ja ne voi lisätä varaukseen muiden laitteiden yhteydessä.
              </>
            }
            ariaLabel="Accordion kysymys: Voinko vuokrata mikrofonit ja telineet erikseen?"
          />

          <Accordion
            title="Miten peruutukset ja muutokset toimivat?"
            onToggle={() =>
              trackAccordion("Miten peruutukset ja muutokset toimivat?")
            }
            answer={
              <>
                Peruutukset ja muutokset tulee tehdä mahdollisimman ajoissa.
                Mahdolliset kulut määräytyvät tapauskohtaisesti varausajankohdan
                ja vuokrauksen laajuuden mukaan.
                <br /><br />
                Ota aina yhteyttä sähköpostitse:{" "}
                <a
                  href="mailto:info@spiderlegsproductions.com"
                  className={linkClass}
                >
                  info@spiderlegsproductions.com
                </a>
              </>
            }
            ariaLabel="Accordion kysymys: Miten peruutukset ja muutokset toimivat?"
          />
        </div>
      </section>
    </>
  );
};

export default UKK;